import { render, staticRenderFns } from "./ModalAnswerTemplateWithMarkers.vue?vue&type=template&id=1d841429&lang=pug&"
import script from "./ModalAnswerTemplateWithMarkers.vue?vue&type=script&lang=js&"
export * from "./ModalAnswerTemplateWithMarkers.vue?vue&type=script&lang=js&"
import style0 from "./ModalAnswerTemplateWithMarkers.vue?vue&type=style&index=0&id=1d841429&prod&lang=sass&"
import style1 from "./ModalAnswerTemplateWithMarkers.vue?vue&type=style&index=1&id=1d841429&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports